<script setup lang="ts">
  import { TabsList, type TabsListProps } from 'reka-ui'
  import { computed, type HTMLAttributes } from 'vue'
  import { cn } from '../../../lib/utils'

  const props = defineProps<
    TabsListProps & { class?: HTMLAttributes['class'] }
  >()

  const delegatedProps = computed(() => {
    const { class: _, ...delegated } = props

    return delegated
  })
</script>

<template>
  <TabsList
    data-slot="tabs-list"
    v-bind="delegatedProps"
    :class="
      cn('bg-secondary relative flex w-fit gap-1 rounded-sm p-1', props.class)
    "
  >
    <slot />
  </TabsList>
</template>
